<template>
    <section>
        <h1 class="mb-0 mt-5 mb-3 text-center">Teachers</h1>

        <v-row>
            <v-col>
                <v-text-field
                        v-model="keyword"
                        label="Search"
                        hide-details
                >
                    <template v-slot:prepend-inner>
                        <svg v-svg="'icon-search'" size="15"></svg>
                    </template>
                </v-text-field>
            </v-col>
        </v-row>

        <v-data-table :headers="headers"
                      :items="users"
                      :page.sync="pagination.current"
                      :items-per-page="pagination.rowsPerPage"
                      hide-default-footer
                      class="elevation-1 mt-13 mb-6"
                      mobile-breakpoint="0"
        >
            <template v-slot:item.avatar="props">
                <v-avatar size="38">
                    <img :src="props.item.avatar || require('@/../public/images/Avatar.png')">
                </v-avatar>
            </template>

            <template v-slot:item.id="props">
                {{(pagination.current - 1)*pagination.rowsPerPage+props.index+1}}
            </template>

            <template v-slot:item.status="props">
                <span v-if="props.item.status_label === 'approved'" class="green--text text--lighten-1 font-weight-bold">Approved</span>
                <span v-else class="red--text font-weight-bold">Deactivated</span>
            </template>

            <template v-slot:item.actions="props">
                <v-btn text class="px-0 mr-1 teams" :to="{name : 'AdminTeams', query: {teacher_id : props.item.id}}">
                    <svg v-svg="'icon-members'" size="12" fill="currentColor" class="mr-1"></svg>
                    <span>Teams</span>
                </v-btn>

                <v-btn text class="px-0 mx-2" @click="[$refs.edit.dialog = true, selectedUser = props.item.id]">
                    <svg v-svg="'icon-edit'" size="12" class="mr-1"></svg>
                    <span class="green--text">Edit</span>
                </v-btn>

                <v-btn text class="px-0 mx-1" @click="[$refs.delete.dialog = true, selectedUser = props.item.id]">
                    <svg v-svg="'icon-delete'" size="12" class="mr-1"></svg>
                    <span class="red--text">Delete</span>
                </v-btn>

                <v-btn text class="px-0 mx-2" @click="generateNewPassword(props.item.id)">
                    <svg v-svg="'icon-new-password'" size="12" class="mr-1"></svg>
                    <span class="pass">New Pass</span>
                </v-btn>

                <v-btn text @click="[$refs.deactivate.dialog = true, selectedUser = props.item.id]" class="px-0 ml-1" :class="{'inactivate': props.item.status_label === 'approved' , 'activate': props.item.status_label === 'deactivated'}">
                    <svg v-svg="'icon-status'" size="12" fill="currentColor" class="mr-1"></svg>
                    <span v-if="props.item.status_label === 'approved'">Inactivate</span>
                    <span v-else>Activate</span>
                </v-btn>
            </template>

            <template v-slot:header.actions class="d-none"></template>
        </v-data-table>

        <div class="float-end mb-5">
            <v-pagination  v-model="pagination.current"
                           :length="pagination.total"
                           :total-visible="3"
                           color="green"
                           @input="getData"
            ></v-pagination>
        </div>

        <v-btn color="green" width="52" height="52" class="create" fab fixed bottom @click="$refs.create.dialog = true">
            <svg v-svg="'icon-create'" size="21"></svg>
        </v-btn>

        <edit ref="edit" :user_id="selectedUser" :is_teacher="true"></edit>
        <delete ref="delete" :user_id="selectedUser"></delete>
        <deactivate ref="deactivate" :user_id="selectedUser"></deactivate>
        <create ref="create" :is_teacher="true"></create>
    </section>
</template>

<script>
    import Edit from '@/components/Admin/User/Edit';
    import Delete from '@/components/Admin/User/Delete';
    import Deactivate from '@/components/Admin/User/Deactivate';
    import Create from '@/components/Admin/User/Create';
    export default {
        components : {
            Edit,
            Delete,
            Deactivate,
            Create,
        },
        data(){
            return {
                timeout: null,
                loadingRequest: false,
                selectedUser: null,
                keyword: null,
                headers: [
                    {text: 'Avatar', sortable: false, value: 'avatar', align: 'center'},
                    {text: '#ID', sortable: false, value: 'id'},
                    {text: 'Full Name', sortable: false, value: 'full_name'},
                    {text: 'Email', sortable: false, value: 'email'},
                    {text: 'Phone', sortable: false, value: 'phone'},
                    {text: 'Status', sortable: false, value: 'status'},
                    {text: 'Actions', sortable: false, value: 'actions', align: 'left', width: '400px'}
                ],
                users: [],
                pagination: {},
            }
        },

        mounted() {
            this.getData();
            this.$on('getData', function () {
                this.getData();
            })
        },

        watch: {
            keyword() {
                clearTimeout(this.timeout);
                this.timeout = setTimeout(() => {
                    this.getData(1);
                }, 300);
            }
        },

        methods: {
            getData(page) {
                this.loadingRequest = true;
                this.$apiAdmin('users').get({params: {page: page, teachers: 1, keyword: this.keyword}}).then((res) => {
                    const response = res.data.users;
                    this.pagination.rowsPerPage = response.per_page;
                    this.pagination.current = response.current_page;
                    this.pagination.total = response.last_page;
                    this.users = response.data;
                }).finally(() => {
                    this.loadingRequest = false;
                })
            },

            generateNewPassword(id) {
                this.$apiAdmin('users').generateNewPassword({id}).then(() => {
                    this.$store.dispatch('alert', {type: 1, message: 'Successfully generated.'});
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../../scss/pages/tablePages";
    @import "../../../scss/pages/Users/teachers";
</style>